<template>
<div class="chapter">
<div class="inner_page">
<h2 class="author">1</h2>
<p class="vers"><span>Du machtest</span> mich endlos
– so<br class="calibre1"/>
ist dein Belieben. Dies schwache Gefäß<br class="calibre1"/>
leertest du wieder und wieder und<br class="calibre1"/>
fülltest es immer mit neuem Leben.</p>
<p class="vers">Du trugst diese kleine Rohrflöte über<br class="calibre1"/>
Hügel und Täler und hauchtest durch sie<br class="calibre1"/>
ewig neue Melodien.</p>
<p class="vers">Bei dem unsterblichen Druck deiner<br class="calibre1"/>
Hände verliert mein kleines Herz seine<br class="calibre1"/>
Grenze in Freude und gebiert unaussprechliche<br class="calibre1"/>
Worte.</p>
<p class="vers">Deine unendlichen Gaben empfange<br class="calibre1"/>
ich nur auf diesen meinen sehr kleinen<br class="calibre1"/>
Händen. Zeitalter vergehn und immer<br class="calibre1"/>
gießest du aus, und immer ist Raum, um<br class="calibre1"/>
erfüllt zu werden. <a id="page4" title="JohannN/wedi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?276a983e